export function initOrderQueue() {
  console.log("SQLite disabled on web");
}

export function addOrderToQueue(order) {
  console.log("Web does not queue printer orders", order);
}
//730dc664ac03

export function getPendingOrders() {
  return [];
}
